// extracted by mini-css-extract-plugin
module.exports = {"grey-theme":"grey-theme-1qbag","greyTheme":"grey-theme-1qbag","wrapper":"wrapper-DtTI8","callout":"callout-1o-GQ","children":"children-3HE7F","icon":"icon-2kIY2"};